import { GetAllEtiquetasDtoProps } from "api/Schemas/GetAllEtiquetasDto"
import { t } from "i18next"

export const DropdownCategoryTemplate = (option: GetAllEtiquetasDtoProps) => {
  return (
    <div className='tw-flex tw-flex-row tw-gap-2'>
      <div
        className={`tw-flex tw-justify-center ${
          option?.nombre ? "tw-min-w-6" : ""
        }`}
      >
        {option?.nombre && (option?.icono ?? "🏷️")}
      </div>
      <div className={option?.nombre ? "" : "tw-opacity-60"}>
        {option?.nombre ?? `${t("tickets.form.placeholder.categoria")}`}
      </div>
    </div>
  )
}
